module.exports = __webpack_public_path__ + "img/trinkwasser_header.898fe431.jpg";